import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import Button from '@Components/Button';

function PreferredSuppliersHeadingClosed({ onOpen, checkedOptionsList }) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="preferred-suppliers-accordion-item__heading rx-accordion-row profile-settings-accordion-row" onClick={onOpen}>
      <span className="profile-settings-accordion-row_label">{ProfileSettingsConfig.Labels.preferredSuppliers}</span>
      <span className="profile-settings-accordion-row_list">
        {checkedOptionsList &&
          checkedOptionsList.map(({ label, name }) => (
            <span key={name} className="preferred-suppliers-item__checked-option  profile-settings-accordion-row_list-tagged">
              {label}
            </span>
          ))}
      </span>
      <div className="preferred-suppliers-accordion-item__controls">
        <Button
          buttonConfig={{
            className: 'preferred-suppliers-accordion-item__edit-button',
            type: 'link',
            size: 'md',
            iconOnly: true,
            ariaLabel: 'Edit',
            e2eName: 'preferred-suppliers-edit',
          }}
          iconConfig={{
            name: 'pencil',
          }}
        />
      </div>
    </div>
  );
}

PreferredSuppliersHeadingClosed.defaultProps = {
  onOpen: () => {},
};

PreferredSuppliersHeadingClosed.propTypes = {
  onOpen: PropTypes.func,
  checkedOptionsList: PropTypes.array,
};

export default PreferredSuppliersHeadingClosed;
